// assets/sidecart.js
(function () {
  const cartURL   = (window.routes && routes.cart_url)        || '/cart';
  const addURL    = (window.routes && routes.cart_add_url)    || '/cart/add.js';
  const changeURL = (window.routes && routes.cart_change_url) || '/cart/change.js';
  const updateURL = (window.routes && routes.cart_update_url) || '/cart/update.js';

  const qs  = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  window.__SC_ATC_LOCK__ = false;

  function isAppstleActive() {
    return !!window.Appstle ||
           !!window.appstleSubscriptionWidget ||
           !!document.querySelector('[data-appstle-subscription-widget]') ||
           !!document.querySelector('.appstle-subscription-widget');
  }

  async function fetchSection(id, retries = 2) {
    const url = new URL(cartURL, window.location.origin);
    url.searchParams.set('section_id', id);
    url.searchParams.set('_', Date.now().toString());
    const res = await fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    });
    if (res.status === 429 && retries > 0) {
      await new Promise(r => setTimeout(r, 600));
      return fetchSection(id, retries - 1);
    }
    if (!res.ok) throw new Error(`Sekcja ${id} niezaładowana`);
    return res.text();
  }

  async function getCart() {
    const res = await fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!res.ok) throw new Error('Nie udało się pobrać koszyka.');
    return res.json();
  }

  // Format raw cents/grosz into money string, matching shop currency where possible.
  function formatMoney(cents) {
    if (window.Shopify?.formatMoney) {
      try { return window.Shopify.formatMoney(cents); } catch {}
    }
    return (cents / 100).toFixed(2).replace('.', ',') + '\u00a0z\u0142';
  }

  // ===== Cart API helpers =====

  async function changeCartLine(line, quantity) {
    const res = await fetch(changeURL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ line, quantity })
    });
    if (!res.ok) {
      let msg = 'Aktualizacja koszyka nie powiodła się.';
      try { const d = await res.json(); msg = d?.message || d?.description || msg; } catch {}
      throw new Error(msg);
    }
    return res.json().catch(() => null);
  }

  // Remove multiple lines at once by their item keys (uses /cart/update.js).
  async function removeLines(keys) {
    if (!keys.length) return;
    const updates = {};
    keys.forEach(k => { updates[k] = 0; });
    const res = await fetch(updateURL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ updates })
    });
    if (!res.ok) {
      let msg = 'Nie udało się usunąć produktu.';
      try { const d = await res.json(); msg = d?.message || d?.description || msg; } catch {}
      throw new Error(msg);
    }
  }

  function normalizeProps(props) {
    const out = {};
    if (!props || typeof props !== 'object') return out;
    Object.keys(props).sort().forEach(k => {
      const v = props[k];
      if (v === '' || v == null) return;
      out[k] = String(v);
    });
    return out;
  }

  function getItemSignature(item) {
    const props = normalizeProps(item.properties || {});
    const planId = item.selling_plan_allocation?.selling_plan?.id
      ? String(item.selling_plan_allocation.selling_plan.id)
      : '';
    return JSON.stringify({ variant_id: String(item.variant_id), properties: props, selling_plan_id: planId });
  }

  // ===== Visual duplicate merging =====
  // Shopify's Automatic Discount splits a line (e.g. qty=2) into full-price + discounted
  // sub-lines. We cannot prevent this at API level — Shopify re-applies it on every change.
  // Instead we group the DOM rows visually: one displayed row per (variant + _deal) identity,
  // with combined quantity and price. Each +/- only moves the primary line's real qty; the
  // secondary (discounted) line stays untouched. On remove, all lines in the group are zeroed.
  function mergeVisualDuplicates() {
    const wrap = qs('cart-drawer.drawer');
    if (!wrap) return;

    const rows = qsa('.cart-item[data-variant-id]', wrap);
    const groups = new Map();

    rows.forEach(row => {
      const sig = (row.dataset.variantId || '') + '|' + (row.dataset.isDeal || '');
      if (!groups.has(sig)) groups.set(sig, []);
      groups.get(sig).push(row);
    });

    groups.forEach(groupRows => {
      const primary       = groupRows[0];
      const primaryInput  = primary.querySelector('.quantity__input');
      const primaryRemove = primary.querySelector('.sc-remove');
      const primaryPrice  = primary.querySelector('.price--end');

      const allKeys = groupRows.map(r => r.dataset.key).filter(Boolean);

      if (groupRows.length === 1) {
        // No split — just annotate for consistent handling
        if (primaryInput && !primaryInput.dataset.primaryQty) {
          primaryInput.dataset.primaryQty  = primaryInput.value;
          primaryInput.dataset.mergedExtra = '0';
        }
        if (primaryRemove) primaryRemove.dataset.keys = allKeys.join(',');
        return;
      }

      // Multiple rows for same identity — compute group totals
      let totalQty   = 0;
      let totalPrice = 0;
      groupRows.forEach(row => {
        const inp = row.querySelector('.quantity__input');
        totalQty  += parseInt(inp?.value || '1', 10);
        totalPrice += parseInt(row.dataset.finalLinePrice || '0', 10);
      });

      const primaryQty  = parseInt(primaryInput?.value || '1', 10);
      const extraQty    = totalQty - primaryQty;

      if (primaryInput) {
        primaryInput.dataset.primaryQty  = String(primaryQty);
        primaryInput.dataset.mergedExtra = String(extraQty);
        primaryInput.value               = String(totalQty);
      }
      if (primaryPrice && totalPrice > 0) {
        primaryPrice.textContent = formatMoney(totalPrice);
      }
      if (primaryRemove) {
        primaryRemove.dataset.keys = allKeys.join(',');
      }

      // Hide secondary rows
      groupRows.slice(1).forEach(row => { row.style.display = 'none'; });
    });
  }

  // ===== Drawer refresh =====

  async function refreshDrawer() {
    const html = await fetchSection('cart-drawer');
    const doc  = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('CartDrawer');
    const old   = document.getElementById('CartDrawer');
    if (fresh && old) {
      old.replaceWith(fresh);
    }
    // Update cart state (total_price etc.) so updateDealBox reads fresh values
    const freshState = doc.querySelector('[data-cart-drawer-state]');
    const oldState   = document.querySelector('[data-cart-drawer-state]');
    if (freshState && oldState) {
      oldState.textContent = freshState.textContent;
    }
  }

  async function refreshBubbleIfExists() {
    const t = document.getElementById('cart-icon-bubble');
    if (!t) return;
    const html = await fetchSection('cart-icon-bubble').catch(() => null);
    if (!html) return;
    const doc   = new DOMParser().parseFromString(html, 'text/html');
    const fresh = doc.getElementById('cart-icon-bubble');
    if (fresh) t.innerHTML = fresh.innerHTML;
  }

  function openDrawer() {
    const wrap = qs('cart-drawer.drawer');
    if (!wrap) return;
    wrap.classList.add('active');
    wrap.style.visibility = 'visible';
    wrap.setAttribute('aria-hidden', 'false');
    (qs('.drawer__inner', wrap) || wrap).focus();
    document.body.classList.add('overflow-hidden');
  }

  function closeDrawer() {
    const wrap = qs('cart-drawer.drawer');
    if (!wrap) return;
    wrap.classList.remove('active');
    wrap.style.visibility = 'hidden';
    wrap.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
  }

  // ===== CROSSELL =====
  let currentUpsellPick = null;
  let upsellIndex = 0;

  function readUpsellPool() {
    const el = document.getElementById('sc-upsell-pool');
    if (!el) return [];
    try { return JSON.parse(el.textContent || '[]'); } catch { return []; }
  }

  function pickRandom(pool, excludeVariantId) {
    if (!Array.isArray(pool) || pool.length === 0) return null;
    let candidates = pool;
    if (excludeVariantId && pool.length > 1) {
      candidates = pool.filter(p => String(p.variant_id) !== String(excludeVariantId));
      if (!candidates.length) candidates = pool;
    }
    return candidates[Math.floor(Math.random() * candidates.length)] || null;
  }

  function renderUpsell(pick) {
    const upsellWrap = document.getElementById('CartDrawer-Upsell');
    if (!upsellWrap || !pick) return;

    upsellWrap.querySelectorAll('.drawer__upsell-link')
      .forEach(a => a.setAttribute('href', pick.url || '#'));

    const imgEl = upsellWrap.querySelector('.drawer__upsell-media img');
    if (imgEl) { imgEl.src = pick.image || ''; imgEl.alt = pick.image_alt || pick.title || ''; }

    const titleEl = upsellWrap.querySelector('.drawer__upsell-title');
    if (titleEl) { titleEl.textContent = pick.title || ''; titleEl.setAttribute('href', pick.url || '#'); }

    const compareEl = upsellWrap.querySelector('.drawer__upsell-compare');
    const priceEl   = upsellWrap.querySelector('.drawer__upsell-price-final');
    if (compareEl && priceEl) {
      if (pick.compare_at_price && pick.compare_at_price !== pick.price) {
        compareEl.style.display = '';
        compareEl.textContent = pick.compare_at_price;
      } else {
        compareEl.style.display = 'none';
        compareEl.textContent = '';
      }
      priceEl.textContent = pick.price || '';
    }

    const btn = upsellWrap.querySelector('.sc-upsell-add');
    if (btn) {
      btn.dataset.variantId = pick.variant_id;
      if (pick.selling_plan_id) btn.dataset.sellingPlanId = pick.selling_plan_id;
      else btn.removeAttribute('data-selling-plan-id');
    }

    upsellWrap.dataset.lastVariantId = String(pick.variant_id || '');
  }

  function navigateUpsell(direction) {
    const pool = readUpsellPool();
    if (!pool.length) return;
    upsellIndex = direction === 'next'
      ? (upsellIndex + 1) % pool.length
      : (upsellIndex - 1 + pool.length) % pool.length;
    currentUpsellPick = pool[upsellIndex];
    if (!currentUpsellPick) return;

    const inner = document.querySelector('#CartDrawer-Upsell .drawer__upsell-inner');
    if (inner) {
      inner.classList.remove('slide-next', 'slide-prev');
      void inner.offsetWidth;
      inner.classList.add(direction === 'next' ? 'slide-next' : 'slide-prev');
      inner.addEventListener('animationend', () => inner.classList.remove('slide-next', 'slide-prev'), { once: true });
    }
    renderUpsell(currentUpsellPick);
  }

  function ensureUpsellRendered({ randomize } = { randomize: false }) {
    const pool = readUpsellPool();
    if (randomize || !currentUpsellPick) {
      const exclude = currentUpsellPick && currentUpsellPick.variant_id;
      currentUpsellPick = pickRandom(pool, exclude);
      if (currentUpsellPick) upsellIndex = pool.indexOf(currentUpsellPick);
    }
    if (currentUpsellPick) renderUpsell(currentUpsellPick);
  }

  // ===== DEAL BOX =====
  function readDealConfig() {
    const el = document.getElementById('sc-deal-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch { return null; }
  }

  function updateDealBox() {
    const config  = readDealConfig();
    const dealBox = document.getElementById('CartDrawer-Deal');
    if (!config || !dealBox) return;

    const rows = Array.from(document.querySelectorAll('.cart-item[data-variant-id]'));
    const offerAlreadyAdded = rows.some(r =>
      String(r.dataset.variantId) === String(config.offer_variant_id) &&
      r.dataset.isDeal === 'true'
    );

    const triggerIds = (config.trigger_product_ids || []).map(String);
    const cartHasTrigger = triggerIds.length > 0
      ? rows.some(r => triggerIds.includes(String(r.dataset.productId)))
      : rows.length > 0;

    if (cartHasTrigger && !offerAlreadyAdded) dealBox.classList.add('is-visible');
    else dealBox.classList.remove('is-visible');
  }

  // ===== GIFT =====
  function readGiftConfig() {
    const el = document.getElementById('sc-gift-config');
    if (!el) return null;
    try { return JSON.parse(el.textContent || 'null'); } catch { return null; }
  }

  // Single getCart() call handles both deal auto-removal and gift add/remove.
  // Merging them prevents double /cart.js fetches and avoids hitting Shopify rate limits.
  async function syncCartState() {
    const dealConfig = readDealConfig();
    const giftConfig = readGiftConfig();

    const dealActive = !!(dealConfig?.offer_variant_id && (dealConfig.trigger_product_ids || []).length > 0);
    const giftActive = !!giftConfig?.gift_variant_id;
    if (!dealActive && !giftActive) return;

    const freshCart     = await getCart();
    const keysToRemove  = [];
    let   shouldAddGift = false;

    if (dealActive) {
      const triggerIds  = dealConfig.trigger_product_ids.map(String);
      const hasTrigger  = freshCart.items.some(item => triggerIds.includes(String(item.product_id)));
      if (!hasTrigger) {
        freshCart.items
          .filter(item =>
            String(item.variant_id) === String(dealConfig.offer_variant_id) &&
            item.properties?._deal === 'true'
          )
          .forEach(item => keysToRemove.push(item.key));
      }
    }

    if (giftActive) {
      const giftItem = freshCart.items.find(item =>
        String(item.variant_id) === String(giftConfig.gift_variant_id) &&
        item.properties?._gift === 'true'
      );

      // Price of deal items queued for removal (affects effective total for gift threshold)
      const dealRemovedPrice = keysToRemove.reduce((acc, key) => {
        const it = freshCart.items.find(i => i.key === key);
        return acc + (it ? (it.final_line_price || 0) : 0);
      }, 0);

      if (giftItem) {
        const effectiveTotal = freshCart.total_price - (giftItem.final_line_price || 0) - dealRemovedPrice;
        if (effectiveTotal < giftConfig.threshold_cents) {
          keysToRemove.push(giftItem.key);
          giftDismissed = false; // threshold dropped naturally — reset so gift re-appears next time
        }
      } else {
        const effectiveTotal = freshCart.total_price - dealRemovedPrice;
        if (effectiveTotal < giftConfig.threshold_cents) {
          giftDismissed = false; // below threshold — reset dismissed state
        } else if (!giftDismissed) {
          shouldAddGift = true;
        }
      }
    }

    if (keysToRemove.length) await removeLines(keysToRemove);
    if (shouldAddGift) {
      const res = await fetch(addURL, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: parseInt(giftConfig.gift_variant_id, 10), quantity: 1, properties: { _gift: 'true' } }] })
      });
      if (!res.ok) console.warn('[Gift] Nie udało się dodać prezentu do koszyka.');
    }
  }

  function updateGiftBar() {
    const config     = readGiftConfig();
    const progressEl = document.getElementById('CartDrawer-GiftProgress');
    if (!config || !progressEl) return;

    const stateEl   = document.querySelector('[data-cart-drawer-state]');
    const state     = stateEl ? JSON.parse(stateEl.textContent || '{}') : {};
    const total     = state.total_price || 0;
    const threshold = config.threshold_cents;

    const textEl = document.getElementById('CartDrawer-GiftText');
    const barEl  = document.getElementById('CartDrawer-GiftBar');

    const rows    = Array.from(document.querySelectorAll('.cart-item[data-variant-id]'));
    const giftRow = rows.find(r =>
      String(r.dataset.variantId) === String(config.gift_variant_id) &&
      r.dataset.isGift === 'true'
    );

    if (giftDismissed && !giftRow) {
      progressEl.classList.remove('is-visible');
      return;
    }

    progressEl.classList.add('is-visible');

    if (giftRow) {
      if (barEl) barEl.style.width = '100%';
      if (textEl) {
        textEl.innerHTML = '<strong>' + (config.gift_label || 'Twój prezent jest w koszyku!') + '</strong>';
      }
    } else {
      const pct       = Math.min(100, Math.round((total / threshold) * 100));
      const remaining = threshold - total;
      if (barEl) barEl.style.width = pct + '%';
      if (textEl) textEl.textContent = 'Dodaj jeszcze ' + formatMoney(remaining) + ', aby otrzymać prezent gratis!';
    }
  }

  async function openDrawerFresh() {
    await syncCartState();
    await refreshDrawer();
    mergeVisualDuplicates();
    bindDrawerHandlers();
    bindQuantityAndRemoveButtons();
    ensureUpsellRendered({ randomize: true });
    updateDealBox();
    updateGiftBar();
    openDrawer();
  }

  // ===== Cart mutations =====
  let busy = false;
  let pendingUpdate = null;
  let giftDismissed = false; // set when user manually removes the gift; cleared when total drops below threshold

  // Update a specific line by its Shopify key.
  // Fetches fresh cart to resolve the current 1-based line number (safe after discount recalculations).
  async function updateLine({ key, quantity }) {
    if (busy) { pendingUpdate = { key, quantity }; return; }
    busy = true;
    pendingUpdate = null;

    try {
      const cart = await getCart();
      const idx  = cart.items.findIndex(item => item.key === key);
      if (idx === -1) throw new Error(`Nie znaleziono pozycji koszyka (key: ${key})`);

      await changeCartLine(idx + 1, quantity);
      await syncCartState();
      await refreshDrawer();
      await refreshBubbleIfExists();
      mergeVisualDuplicates();
      ensureUpsellRendered({ randomize: false });
      updateDealBox();
      updateGiftBar();
    } catch (e) {
      console.error(e);
      alert(e?.message || 'Nie udało się zaktualizować koszyka.');
    } finally {
      bindDrawerHandlers();
      bindQuantityAndRemoveButtons();
      busy = false;
      if (pendingUpdate) {
        const q = pendingUpdate; pendingUpdate = null;
        updateLine(q);
      }
    }
  }

  // Remove one or more lines by key in a single request, then refresh.
  async function removeLinesAction(keys) {
    if (busy) { pendingUpdate = { _removeKeys: keys }; return; }
    busy = true;
    pendingUpdate = null;

    try {
      // Detect manual gift removal from DOM (no extra API call needed)
      const giftCfg = readGiftConfig();
      if (giftCfg?.gift_variant_id) {
        const rows = Array.from(document.querySelectorAll('.cart-item[data-variant-id]'));
        const removingGift = keys.some(key => rows.find(r => r.dataset.key === key)?.dataset.isGift === 'true');
        if (removingGift) giftDismissed = true;
      }

      await removeLines(keys);
      await syncCartState();
      await refreshDrawer();
      await refreshBubbleIfExists();
      mergeVisualDuplicates();
      ensureUpsellRendered({ randomize: false });
      updateDealBox();
      updateGiftBar();
    } catch (e) {
      console.error(e);
      alert(e?.message || 'Nie udało się usunąć produktu.');
    } finally {
      bindDrawerHandlers();
      bindQuantityAndRemoveButtons();
      busy = false;
    }
  }

  // Add or increase — checks for identical existing line before calling add.js.
  async function addOrIncreaseItem({ variantId, quantity = 1, isDeal = false, sellingPlanId = '' }) {
    const targetProps = isDeal ? { _deal: 'true' } : {};
    const targetSig   = JSON.stringify({
      variant_id:      String(variantId),
      properties:      normalizeProps(targetProps),
      selling_plan_id: String(sellingPlanId || '')
    });

    const cart          = await getCart();
    const existingIndex = cart.items.findIndex(item => getItemSignature(item) === targetSig);

    if (existingIndex > -1) {
      const existing = cart.items[existingIndex];
      await changeCartLine(existingIndex + 1, existing.quantity + quantity);
      return;
    }

    const item = { id: parseInt(variantId, 10), quantity };
    if (isDeal)        item.properties   = { _deal: 'true' };
    if (sellingPlanId) item.selling_plan = sellingPlanId;

    const res = await fetch(addURL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ items: [item] })
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err?.description || err?.message || 'Nie udało się dodać produktu.');
    }
  }

  // ===== Event handlers =====

  function bindQuantityAndRemoveButtons() {
    const wrap = qs('cart-drawer.drawer');
    if (!wrap) return;

    qsa('.quantity__button', wrap).forEach(btn => {
      if (btn.dataset.scQtyBound === 'true') return;
      btn.dataset.scQtyBound = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        const line  = parseInt(btn.dataset.line, 10);
        const input = qs(`#Drawer-quantity-${line}`, wrap);
        if (!input) return;
        const key = input.dataset.key;
        if (!key) return;

        // primaryQty = actual qty of this specific Shopify line (not the visual merged total)
        const primaryQty = parseInt(input.dataset.primaryQty || input.value, 10);
        const isPlus     = btn.getAttribute('name') === 'plus';
        const step       = parseInt(input.step || '1', 10);
        const min        = parseInt(input.min  || '1', 10);
        const max        = input.max ? parseInt(input.max, 10) : null;
        let newQty       = isPlus ? primaryQty + step : Math.max(min, primaryQty - step);
        if (max !== null) newQty = Math.min(max, newQty);

        updateLine({ key, quantity: newQty });
      }, { capture: true });
    });

    qsa('.sc-remove', wrap).forEach(btn => {
      if (btn.dataset.scRemoveBound === 'true') return;
      btn.dataset.scRemoveBound = 'true';
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();
        const keys = (btn.dataset.keys || btn.dataset.key || '').split(',').filter(Boolean);
        if (!keys.length) return;
        removeLinesAction(keys);
      }, { capture: true });
    });

    qsa('.quantity__input', wrap).forEach(input => {
      if (input.dataset.scChangeBound === 'true') return;
      input.dataset.scChangeBound = 'true';
      input.addEventListener('change', (e) => {
        e.stopImmediatePropagation();
        e.stopPropagation();
        const key = input.dataset.key;
        if (!key) return;
        // User typed a value — it's the desired visual total.
        // Translate to the primary line's new qty by subtracting the secondary (discount-split) qty.
        const displayedQty = parseInt(input.value || '1', 10);
        const mergedExtra  = parseInt(input.dataset.mergedExtra || '0', 10);
        const newPrimaryQty = Math.max(1, displayedQty - mergedExtra);
        input.dataset.primaryQty = String(newPrimaryQty);
        updateLine({ key, quantity: newPrimaryQty });
      }, { capture: true });
    });
  }

  function bindDrawerHandlers() {
    const wrap = qs('cart-drawer.drawer');
    if (!wrap || wrap.dataset.bound === 'true') return;

    wrap.addEventListener('click', (e) => {
      if (e.target.closest('#CartDrawer-Overlay, #CartDrawer-CloseBtn')) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      const navBtn = e.target.closest('.drawer__upsell-nav-btn');
      if (navBtn) {
        e.preventDefault();
        navigateUpsell(navBtn.classList.contains('drawer__upsell-nav-btn--prev') ? 'prev' : 'next');
        return;
      }

      // Deal box
      const dealBtn = e.target.closest('.sc-deal-add');
      if (dealBtn) {
        e.preventDefault();
        const vid = dealBtn.dataset.variantId;
        if (!vid) return;
        (async () => {
          try {
            dealBtn.setAttribute('aria-busy', 'true');
            await addOrIncreaseItem({ variantId: vid, quantity: 1, isDeal: true });
            await syncCartState();
            await refreshDrawer();
            await refreshBubbleIfExists();
            mergeVisualDuplicates();
            bindDrawerHandlers();
            bindQuantityAndRemoveButtons();
            ensureUpsellRendered({ randomize: false });
            updateDealBox();
            updateGiftBar();
            openDrawer();
          } catch (err) {
            console.error(err);
            alert(err?.message || 'Wystąpił błąd podczas dodawania do koszyka.');
          } finally {
            dealBtn.removeAttribute('aria-busy');
          }
        })();
        return;
      }

      // Crossell
      const upsellBtn = e.target.closest('.sc-upsell-add');
      if (upsellBtn) {
        e.preventDefault();
        const vid    = upsellBtn.dataset.variantId;
        const planId = upsellBtn.dataset.sellingPlanId || '';
        if (!vid) return;

        (async () => {
          try {
            upsellBtn.setAttribute('aria-busy', 'true');
            const appstleActive = isAppstleActive();

            if (appstleActive && planId) {
              const fd = new FormData();
              fd.append('id', vid);
              fd.append('quantity', '1');
              fd.append('selling_plan', planId);
              fd.append('properties[subscription_id]', planId);
              fd.append('properties[_appstle_subscription]', 'true');
              const res = await fetch('/apps/subscriptions/cart/add', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
                body: fd
              });
              if (!res.ok) {
                const err = await res.json().catch(() => ({}));
                throw new Error(err?.description || err?.message || 'Nie udało się dodać produktu.');
              }
            } else {
              await addOrIncreaseItem({ variantId: vid, quantity: 1, isDeal: false, sellingPlanId: planId });
            }

            await syncCartState();
            await refreshDrawer();
            await refreshBubbleIfExists();
            mergeVisualDuplicates();
            bindDrawerHandlers();
            bindQuantityAndRemoveButtons();
            ensureUpsellRendered({ randomize: false });
            updateDealBox();
            updateGiftBar();
            openDrawer();
          } catch (err) {
            console.error(err);
            alert(err?.message || 'Wystąpił błąd podczas dodawania do koszyka.');
          } finally {
            upsellBtn.removeAttribute('aria-busy');
          }
        })();
        return;
      }
    });

    wrap.dataset.bound = 'true';
  }

  // Cart icon (desktop + mobile)
  function bindCartIcon() {
    document.querySelectorAll('.js-open-cart, #cart-icon-bubble').forEach(el => {
      if (el.dataset.scBound === 'true') return;
      el.dataset.scBound = 'true';

      el.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        openDrawerFresh();
      }, { capture: true });

      el.addEventListener('keydown', (e) => {
        if (e.code === 'Space' || e.code === 'Enter') {
          e.preventDefault();
          openDrawerFresh();
        }
      });
    });
  }

  // On page load: remove gift if it's in the cart without the threshold being met.
  // Catches direct URL abuse (/cart/add?id=...) even before the drawer is opened.
  async function auditGiftOnLoad() {
    const giftConfig = readGiftConfig();
    if (!giftConfig?.gift_variant_id) return;

    // Skip audit on empty carts to save an API call
    const stateEl = document.querySelector('[data-cart-drawer-state]');
    const state   = stateEl ? JSON.parse(stateEl.textContent || '{}') : {};
    if ((state.item_count || 0) === 0) return;

    try {
      const cart = await getCart();

      // Match any item with the gift variant ID — regardless of properties —
      // so direct /cart/add?id=... bypasses (which lack _gift:true) are also caught.
      const giftItems = cart.items.filter(item =>
        String(item.variant_id) === String(giftConfig.gift_variant_id)
      );
      if (!giftItems.length) return;

      const giftTotal        = giftItems.reduce((acc, i) => acc + (i.final_line_price || 0), 0);
      const effectiveTotal   = cart.total_price - giftTotal;

      if (effectiveTotal < giftConfig.threshold_cents) {
        await removeLines(giftItems.map(i => i.key));
        await refreshBubbleIfExists();
      }
    } catch (e) {
      console.warn('[Gift] Audit on load failed:', e);
    }
  }

  // init
  mergeVisualDuplicates();
  bindDrawerHandlers();
  bindQuantityAndRemoveButtons();
  bindCartIcon();
  auditGiftOnLoad();

  // PDP form intercept
  (function bindProductForm() {
    const form =
      document.querySelector('product-form form') ||
      document.querySelector('form[action*="/cart/add"]');
    if (!form || form.dataset.sidecartBound === 'true') return;
    form.dataset.sidecartBound = 'true';

    // Read selling_plan from DOM — mirrors sticky-notification logic.
    // FormData alone misses Appstle plans injected outside the form or after submit.
    function getSellingPlanIdFromDom() {
      // 1. Standard Shopify inputs inside the form
      let sel = form.querySelector('input[name="selling_plan"][type="radio"]:checked, select[name="selling_plan"], input[name="selling_plan"][type="hidden"]');
      // 2. Anywhere in DOM (Appstle can render outside the form)
      if (!sel) sel = document.querySelector('input[name="selling_plan"][type="radio"]:checked, select[name="selling_plan"], input[name="selling_plan"][type="hidden"]');
      if (sel && sel.value) return sel.value;
      // 3. Appstle-specific hidden inputs / data attributes
      const appstleHidden =
        document.querySelector('input.appstle_selected_selling_plan_id') ||
        document.querySelector('input[name="appstle_selected_selling_plan_id"]') ||
        document.querySelector('[data-appstle-selected-selling-plan-id]');
      if (appstleHidden) {
        const val = appstleHidden.value || appstleHidden.getAttribute('data-appstle-selected-selling-plan-id');
        if (val) return val;
      }
      // 4. Global Appstle objects
      try {
        const g = window.Appstle || window.AppstleSubscription || window.AppstleThemesPlus || {};
        const id = g.selectedSellingPlanId || g.sellingPlanId || (g.status && g.status.sellingPlanId);
        if (id) return String(id);
      } catch {}
      return '';
    }

    const handleAddToCart = async (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();

      if (window.__SC_ATC_LOCK__) return;
      window.__SC_ATC_LOCK__ = true;

      const btn = form.querySelector('[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');

      try {
        // Read key fields directly — same approach as sticky-notification.
        // FormData alone misses Appstle selling_plan injected outside the form.
        const variantInput  = form.querySelector('input[name="id"], select[name="id"]');
        const quantityInput = form.querySelector('input[name="quantity"]');
        const variantId     = variantInput  ? parseInt(variantInput.value,  10) : null;
        const quantity      = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
        const sellingPlanId = getSellingPlanIdFromDom();

        if (!variantId) throw new Error('Nie znaleziono wariantu produktu.');

        const appstleActive = isAppstleActive();
        const hasPlan       = !!sellingPlanId;
        let res;

        if (appstleActive && hasPlan) {
          // Appstle endpoint expects FormData — supplement with detected plan
          const fd = new FormData(form);
          if (!fd.get('selling_plan')) fd.set('selling_plan', sellingPlanId);
          res = await fetch('/apps/subscriptions/cart/add', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: fd
          });
        } else {
          // Standard /cart/add.js with JSON payload (includes selling_plan when present)
          const item = { id: variantId, quantity };
          if (sellingPlanId) item.selling_plan = parseInt(sellingPlanId, 10);
          res = await fetch(addURL, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [item] })
          });
        }

        if (res.status === 429) {
          await new Promise(r => setTimeout(r, 300));
          const item2 = { id: variantId, quantity };
          if (sellingPlanId) item2.selling_plan = parseInt(sellingPlanId, 10);
          const targetURL = (appstleActive && hasPlan) ? '/apps/subscriptions/cart/add' : addURL;
          const res2 = await fetch(targetURL, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [item2] })
          });
          if (!res2.ok) throw new Error('Nie udało się dodać produktu do koszyka.');
        } else if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err?.description || err?.message || 'Nie udało się dodać produktu do koszyka.');
        }

        await refreshBubbleIfExists();
        await openDrawerFresh();
      } catch (err) {
        console.error(err);
        alert(err?.message || 'Wystąpił błąd podczas dodawania do koszyka.');
      } finally {
        if (btn) btn.removeAttribute('aria-busy');
        setTimeout(() => { window.__SC_ATC_LOCK__ = false; }, 200);
      }
    };

    form.addEventListener('submit', handleAddToCart, { capture: true });
    qsa('[type="submit"]', form).forEach(btn => {
      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        if (!window.__SC_ATC_LOCK__) handleAddToCart(ev);
      }, { capture: true });
    });
  })();
})();
